import type { BidQrCodesModel, GenerateResponseTitleModel, TitleGetModel, WaybillStatusApplyModel } from "api";
import { alertRequest, body, request } from "services/request";
import { generateChangeTitle } from "./waybills";

const resource = "api/waybills";

const getTitle = (waybillId: number, titleId: number) =>
    request(`${resource}/getTitle?waybillId=${waybillId}&titleId=${titleId}`, { method: "GET" });

const getReadableTitle = (waybillId: number, titleId: number) =>
    request(
        `${resource}/getReadableTitle?waybillId=${waybillId}&titleId=${titleId}`,
        { method: "GET" },
        { textBody: true },
    );

const getQrCodes = (bidId: number): Promise<BidQrCodesModel | false> =>
    request(`${resource}/getQrCodes/${bidId}`, { method: "GET" });

type GenerateResponseTitleResult = TitleGetModel | { errorText: string } | false;

const generateResponseTitle = (params: GenerateResponseTitleModel): Promise<GenerateResponseTitleResult> =>
    request(`${resource}/generateResponseTitle`, body(params), {
        withoutErrorAlert: true,
        returnErrorText: true,
    });

const applySignature = (params: {}) => alertRequest(`${resource}/applySignature`, params);

const applyStatus = (params: WaybillStatusApplyModel) => alertRequest(`${resource}/applyStatus`, body(params));

const getPrintFormFromExternal = (waybillId: number): Promise<Response> =>
    request(
        `${resource}/getPrintFormFromExternal?waybillId=${waybillId}`,
        { method: "GET" },
        { withoutMiddleware: true, withoutConnectionAlert: true },
    );

export {
    getTitle,
    generateResponseTitle,
    generateChangeTitle,
    applySignature,
    applyStatus,
    getQrCodes,
    getReadableTitle,
    getPrintFormFromExternal,
};
